import type { IconName } from '@cbhq/cds-common';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { HStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography/Text';

type AuditDetailHeaderProps = {
  iconName: IconName;
  title: string;
};

export function AuditDetailHeader({ iconName, title }: AuditDetailHeaderProps) {
  return (
    <HStack
      alignItems="center"
      gap={1.5}
      paddingX={4}
      paddingY={1}
      width="100%"
      testID="audit-detail-header"
    >
      <Icon name={iconName} size="m" color="fg" />
      <Text as="p" font="title3" color="fg">
        {title}
      </Text>
    </HStack>
  );
}
